import React, { useEffect, useState } from 'react';
// // Core viewer
import { Button, Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
// // Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
// import { scrollModePlugin } from '@react-pdf-viewer/scroll-mode';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import { getpdfdata } from '../../../../Utils/apiServices';
import '../../../../style/index.css';
import { sendMailQuestion } from '../../../../Utils/sendMail';
export const ViewQuestionPaperPdf1 = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const [urlPdf, setUrlPdf] = useState();

  const getAPI = async () => {
    let ab = await getpdfdata();
    return ab[0].versionData;
  };

  const base64toBlob = (data) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr(
      'data:application/pdf;base64,'.length
    );

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: 'application/pdf' });
  };

  const blo = async () => {
    const str = await getAPI();
    const blob = base64toBlob(str);
    let url = URL.createObjectURL(blob);
    console.log('urlurlurlurlurlurlurl', url);
    setUrlPdf(url);
  };
  console.log('urlPdfurlPdfurlPdfurlPdf', urlPdf);

  // const blob = base64toBlob(getAPI());
  // const url = URL.createObjectURL(blob);

  // console.log('urlPdfurlPdfurlPdfurlPdf', urlPdf);

  useEffect(() => {
    blo();
  }, []);

  const mailApproved = () => {
    sendMailQuestion();
  };
  return (
    <>
      <div
        style={{
          height: '500px',
          width: '48%',
          marginRight: '10px',
        }}
      >
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
          <Viewer
            fileUrl={
              urlPdf
                ? urlPdf
                : 'blob:http://localhost:3000/56e9c859-09d8-43cf-a4b2-7cdab8704d0f'
            }
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
        <div className="col-12">
          <Button
            variant="primary"
            className="col-btn"
            // component={Link}
            // className={classOfBtn}
            // to={`${routes.seatingPlan}/arrangement/${id}`}
            onClick={() => {
              mailApproved();
            }}
          >
            Approve
          </Button>
          <Button
            variant="primary"
            // component={Link}
            // className={classes.publishGenerate}
            // // to={`${routes.currentProgrammes}/${id}/details`}
          >
            Remind
          </Button>
        </div>
      </div>
    </>
  );
};
